import { Component } from '@angular/core';
import { AdminDashboardComponent } from '../dashboard/dashboard.component';

@Component({
  selector: 'app-admin-home',
  standalone: true,
  imports: [AdminDashboardComponent],
  template: '<app-admin-dashboard></app-admin-dashboard>',
})
export class AdminHomeComponent {
  // Home component acts as an entry point that renders the dashboard component
}


